import request from '@/utils/service'

export function addSystemNotify(data) {
  return request({
    url: '/systemNotice/add',
    method: 'post',
    data
  })
}

export function systemNoticeList(data) {
  return request({
    url: '/systemNotice/list',
    method: 'get',
    params: data
  })
}

export function systemNoticeDel(data) {
  return request({
    url: '/systemNotice/delete',
    method: 'post',
    data
  })
}

export function systemNoticeUpdate(data) {
  return request({
    url: '/systemNotice/update',
    method: 'post',
    data
  })
}

export function systemNoticeDetail(data) {
  return request({
    url: '/systemNotice/detail',
    method: 'get',
    params: data
  })
}
